import { FC } from 'react';
import { IconButton, Modal } from '@hopskipdrive/react-components';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { useRiderDetailsQuery } from '../../../hooks/useRiderDetailsQuery';
import { RiderDetailsPresenter, RiderMainHeading } from '../../RiderDetailsPresenter';

import { StyledModal } from './RiderInfoModal.styles';

interface RiderInfoModalProps {
  riderSlug: string;
  organizerName: string;
  profileUrl: string;
  onClose: () => void;
}

const RiderInfoModal: FC<RiderInfoModalProps> = ({ riderSlug, organizerName, profileUrl, onClose }) => {
  const { data: riderDetailsResult, isFetching } = useRiderDetailsQuery({ riderSlug: riderSlug });

  const riderDetails = riderDetailsResult?.data;

  return (
    <StyledModal onClose={onClose} open={!!riderSlug}>
      <Modal.Content>
        <RiderMainHeading orgName={organizerName} slug={riderSlug}>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseRoundedIcon />
          </IconButton>
        </RiderMainHeading>
        <RiderDetailsPresenter
          riderSlug={riderSlug}
          profileUrl={profileUrl}
          riderDetails={riderDetails}
          isFetching={isFetching}
        />
      </Modal.Content>
    </StyledModal>
  );
};

export default RiderInfoModal;
